<header class="flex h-16 w-full items-center justify-between
         bg-white px-6 shadow-sm border-b border-slate-200">

  <!-- LEFT : LOGO -->
  <div class="flex items-center gap-3">
    <i class="fas fa-bus text-2xl text-yellow-500"></i>
    <div class="leading-tight">
      <div class="text-lg font-bold text-slate-900">Busly</div>
      <div class="text-xs text-slate-500">Bus Transport System</div>
    </div>
  </div>

  <!-- RIGHT : COMPANY + USER -->
  <div class="flex items-center gap-6">

    <!-- Company -->
    <div class="hidden sm:flex items-center gap-2 text-sm text-slate-700">

      <span class="font-semibold">
        {{ companyName }}
      </span>

      <span class="text-slate-400">|</span>

      <span>
        {{ role }}
      </span>

    </div>

    <!-- User Avatar + Dropdown -->
    <div class="relative" (clickOutside)="isMenuOpen = false">

      <!-- Trigger -->
      <div class="flex items-center gap-3 cursor-pointer select-none" (click)="toggleMenu()">
        <div class="relative">
          <img src="assets/img/default-profile.jpg"
            class="h-9 w-9 rounded-full border-2 border-slate-200 hover:border-yellow-400 transition-colors duration-200"
            alt="User" />
          <span class="absolute bottom-0 right-0 h-2.5 w-2.5 rounded-full bg-green-500 border-2 border-white"></span>
        </div>
        <span class="hidden md:block text-sm font-medium text-slate-800">{{ userName }}</span>
        <i class="fas fa-chevron-down text-xs text-slate-400 hidden md:block transition-transform duration-200"
          [class.rotate-180]="isMenuOpen"></i>
      </div>

      <!-- Dropdown Menu -->
      <div *ngIf="isMenuOpen" class="absolute right-0 mt-3 w-56 rounded-xl bg-white shadow-xl border border-slate-100
                  z-50 overflow-hidden animate-dropdown">

        <!-- User Info Header -->
        <div class="px-4 py-3 bg-slate-50 border-b border-slate-100">
          <p class="text-sm font-semibold text-slate-800 truncate">{{ userName }}</p>
          <p class="text-xs text-slate-500 mt-0.5">{{ role }}</p>
        </div>

        <!-- Menu Items -->
        <div class="py-1">
          <a href="#" class="menu-item"  (click)="navigateToProfile($event)">
            <i class="fas fa-user-circle w-4 text-slate-400"></i>
            <span>My Profile</span>
          </a>
          <a href="#" class="menu-item" (click)="closeMenu($event)">
            <i class="fas fa-cog w-4 text-slate-400"></i>
            <span>Settings</span>
          </a>
          <a href="#" class="menu-item" (click)="closeMenu($event)">
            <i class="fas fa-bell w-4 text-slate-400"></i>
            <span>Notifications</span>
            <span class="ml-auto text-xs bg-yellow-400 text-white font-bold px-1.5 py-0.5 rounded-full">3</span>
          </a>
          <a href="#" class="menu-item" (click)="closeMenu($event)">
            <i class="fas fa-shield-alt w-4 text-slate-400"></i>
            <span>Privacy</span>
          </a>
        </div>

        <div class="border-t border-slate-100"></div>

        <!-- Logout trigger — calls openLogoutModal, NOT logout() directly -->
        <div class="py-1">
          <a href="#" class="menu-item text-red-500 hover:bg-red-50 hover:text-red-600"
            (click)="openLogoutModal($event)">
            <i class="fas fa-sign-out-alt w-4"></i>
            <span>Logout</span>
          </a>
        </div>

      </div>
    </div>

  </div>
</header>


<!-- ═══════════════════  LOGOUT CONFIRMATION MODAL  ═══════════════════ -->
<div class="logout-backdrop" *ngIf="showLogoutModal" (click)="closeLogoutModal()">
  <div class="logout-modal" (click)="$event.stopPropagation()">

    <div class="logout-icon-ring">
      <i class="fas fa-sign-out-alt"></i>
    </div>

    <h3 class="logout-title">Sign out?</h3>
    <p class="logout-body">Are you sure you want to logout?</p>

    <div class="logout-actions">
      <button class="btn-cancel" (click)="closeLogoutModal()">Cancel</button>
      <button class="btn-confirm" (click)="confirmLogout()" [disabled]="isLoggingOut">
        <span *ngIf="isLoggingOut" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
        </span>
        {{ isLoggingOut ? 'Signing out…' : 'Logout' }}
      </button>
    </div>

  </div>
</div>
